'use strict';
/**
 * Dependencies
 */

var _classCallCheck = require("/codebuild/output/src2043515612/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src2043515612/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src2043515612/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/codebuild/output/src2043515612/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src2043515612/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/codebuild/output/src2043515612/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var chalk = require('chalk');
/**
 * Response error class
 */


var ResponseError = /*#__PURE__*/function (_Error) {
  _inherits(ResponseError, _Error);

  var _super = _createSuper(ResponseError);

  /**
   * Constructor
   */
  function ResponseError(response) {
    var _this;

    _classCallCheck(this, ResponseError);

    //Super
    _this = _super.call(this); //Extract data from response

    var headers = response.headers,
        statusCode = response.statusCode,
        statusMessage = response.statusMessage,
        body = response.body; //Set data

    _this.code = statusCode;
    _this.message = statusMessage;
    _this.response = {
      headers: headers,
      body: body
    }; //Capture stack trace

    if (!_this.stack) {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    } //Clean up stack trace


    var regex = new RegExp(process.cwd() + '/', 'gi');
    _this.stack = _this.stack.replace(regex, '');
    return _this;
  }
  /**
   * Convert to string
   */


  _createClass(ResponseError, [{
    key: "toString",
    value: function toString() {
      var body = this.response.body;
      var err = chalk.red("".concat(this.message, " (").concat(this.code, ")"));

      if (body && Array.isArray(body.errors)) {
        body.errors.forEach(function (error) {
          var message = chalk.yellow(error.message);
          var field = chalk.grey(error.field);
          var help = chalk.grey(error.help);
          err += "\n  ".concat(message, "\n    ").concat(field, "\n    ").concat(help);
        });
      }

      return err;
    }
    /**
     * Convert to simple object for JSON responses
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var message = this.message,
          code = this.code,
          response = this.response;
      return {
        message: message,
        code: code,
        response: response
      };
    }
  }]);

  return ResponseError;
}( /*#__PURE__*/_wrapNativeSuper(Error)); //Export


module.exports = ResponseError;